import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import formatCurrency from '@afosto/utils/formatCurrency';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import translations from './translations';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const ORDERS_APP_ORIGIN = BASE_URL.replace('{app}', 'orders');

const TransactionListItem = ({ transaction }) => {
  const intl = useIntl();
  const isSameOrigin = window.location.origin === ORDERS_APP_ORIGIN;

  return (
    <>
      <Divider />
      <ListItem
        button
        {...(isSameOrigin
          ? { component: Link, to: `/transactions/${transaction?.id}` }
          : { href: `${ORDERS_APP_ORIGIN}/transactions/${transaction?.id}` })}
      >
        <Box flex={1} py={1}>
          <Box display="flex" justifyContent="space-between" alignItems="baseline" mb={1}>
            <Typography variant="subtitle1">{transaction?.number ?? 'Concept'}</Typography>
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Typography variant="caption" color="textSecondary" gutterBottom>
                {formatDateTime(transaction?.created_at)}
              </Typography>
              <Chip
                size="small"
                variant="outlined"
                color={transaction?.is_paid ? 'default' : 'secondary'}
                label={
                  transaction?.is_paid
                    ? intl.formatMessage(translations.status.paid)
                    : intl.formatMessage(translations.status.unpaid)
                }
              />
            </Box>
          </Box>
          <Grid container spacing={1} justify="flex-end">
            <Grid item xs={6}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.amountDue)}
              </Typography>
              <Typography variant="subtitle1">
                {formatCurrency(transaction?.amount_due / 100)}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.amountPaid)}
              </Typography>
              <Typography variant="subtitle1">
                {formatCurrency(transaction?.amount_paid / 100)}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </ListItem>
    </>
  );
};

TransactionListItem.propTypes = {
  transaction: PropTypes.object,
};

TransactionListItem.defaultProps = {
  transaction: null,
};

export default TransactionListItem;
